module.exports = __webpack_public_path__ + "PTSans-NarrowBold.7b36357a8b571593d4a0.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/PTSans-NarrowBold.eot
// module id = ../../../../../src/assets/customfonts/PTSans-NarrowBold.eot
// module chunks = styles